import { Button } from '../../components/Buttons'
import img from './assets/TechnicalDifficulties.svg'

import { s } from './styles'

type Props = {
  title?: string
  subTitle?: string
}

export const TechnicalDifficulties = (props: Props) => {
  const { title, subTitle } = props

  return (
    <s.Box>
      <s.Img dangerouslySetInnerHTML={{ __html: img }} />
      <s.Title>{title || 'Technical Difficulties'}</s.Title>
      <s.SubTitle>{subTitle || "We're working to fix this. Please try again soon."}</s.SubTitle>
      <a href="/">
        <Button face="primary">Go home</Button>
      </a>
    </s.Box>
  )
}
